import * as React from "react"
import { Link, graphql } from "gatsby"
import Layout from "../components/layout"
import Seo from "../components/SEO/seo"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import AniLink from "gatsby-plugin-transition-link/AniLink";
import { CenterTitle } from "../components/titles/titles"


const BlogIndex = ({ data, location }) => {
  const siteTitle = data.site.siteMetadata?.title || `Title`
  const posts = data.allMarkdownRemark.nodes
  if (posts.length === 0) {
    return (
      <Layout location={location} title={siteTitle}>

        <Seo title="All posts" />
        {/*<Bio />*/}
        <p>
          No blog posts found. Add markdown posts to "content/blog" (or the
          directory you specified for the "gatsby-source-filesystem" plugin in
          gatsby-config.js).
        </p>
      </Layout>
    )
  }

  return (
    <Layout location={location} title={siteTitle}>
      <Seo title="All posts" />

      <div className="container py-5">
        <CenterTitle subcolor="Our " title="Blog"  subtitle="Latest tips and information"/>
        <ul className="row p-0 mt-5" style={{ listStyle: `none` }}>
          {posts.map(post => {
            const title = post.frontmatter.title || post.fields.slug
            const image = getImage(post.frontmatter.featuredImage)
            return (
              <li className="col-md-4" key={post.fields.slug}>
                <article
                  className="card border-0"
                  itemScope
                  itemType="http://schema.org/Article"
                >
                  <AniLink fade to={post.fields.slug} itemProp="url">
                    <GatsbyImage image={image} />
                  </AniLink>


                  <div className="card-body">
                    <h5 className="card-title">
                      <AniLink fade to={post.fields.slug} itemProp="url">
                        <span itemProp="">{title}</span>
                      </AniLink>
                    </h5>
                    <small className="text-muted py-2">{post.frontmatter.date}</small>
                    <p
                      dangerouslySetInnerHTML={{
                        __html: post.frontmatter.description || post.excerpt,
                      }}
                      itemProp="description"
                    />
                  </div>
                </article>
              </li>
            )
          })}
        </ul>
      </div>

    </Layout>
  )
}

export default BlogIndex

export const pageQuery = graphql`
  query {
    site {
      siteMetadata {
        title
      }
    }
    allMarkdownRemark(sort: { fields: [frontmatter___date], order: DESC }) {
      nodes {
        excerpt
        fields {
          slug
        }
        frontmatter {
          date(formatString: "MMMM DD, YYYY")
          title
          category
          tags
          description
          featuredImage {
          childImageSharp {
          gatsbyImageData(
             formats: [AUTO, WEBP, AVIF]
              placeholder: DOMINANT_COLOR
              breakpoints: [750, 1080, 1366, 1920]
          )
        }
        }
        }
      }
    }
  }
`
